export const GET_TIPPANI = 'GET_TIPPANI';
export const GET_VISA_TRANSFER = 'GET_VISA_TRANSFER';
export const SAVE_VISA_TRANSFER_TIPPANI = 'SAVE_VISA_TRANSFER_TIPPANI';
export const CHECK_VISA_TRANSFER_PAYMENT_STATUS = 'CHECK_VISA_TRANSFER_PAYMENT_STATUS';
export const REJECT_VISA_TRANSFER = 'REJECT_VISA_TRANSFER';
export const APPROVE_VISA_TRANSFER = 'APPROVE_VISA_TRANSFER';
export const PRINT_VISA_TRANSFER = 'PRINT_VISA_TRANSFER';
export const GENERATE_TRANSFER_VOUCHER = 'GENERATE_TRANSFER_VOUCHER';
export const VERIFY_TRANSFER_CERTIFICATION = 'VERIFY_TRANSFER_CERTIFICATION';


export const GET_VISA_CERTIFICATION = 'GET_VISA_CERTIFICATION';
export const SAVE_VISA_CERTIFICATION_TIPPANI = 'SAVE_VISA_CERTIFICATION_TIPPANI';
export const CHECK_VISA_CERTIFICATION_PAYMENT_STATUS = 'CHECK_VISA_CERTIFICATION_PAYMENT_STATUS';
export const REJECT_VISA_CERTIFICATION = 'REJECT_VISA_CERTIFICATION';
export const APPROVE_VISA_CERTIFICATION = 'APPROVE_VISA_CERTIFICATION';
export const GENERATE_VOUCHER = 'GENERATE_VOUCHER';
export const VERIFY_CERTIFICATION = 'VERIFY_CERTIFICATION';

export const GET_TIPPANI_WITH_TYPE = 'GET_TIPPANI_WITH_TYPE';

export const FORWARD_CERTIFICATION = 'FORWARD_CERTIFICATION';
export const VERIFY_APPROVE_TIPPANI_CERTIFICATION = 'VERIFY_APPROVE_TIPPANI_CERTIFICATION';